module.exports = __webpack_public_path__ + "img/manage-payment.df1ac7a1.svg";